import * as React from 'react';
import { Question } from '../types/questionnaire.types';

export const useQuestionResponses = () => {
  const [responses, setResponses] = React.useState<Record<string, string>>({});

  const updateResponse = React.useCallback(
    (questionId: string, value: string) => {
      setResponses((prev) => ({
        ...prev,
        [questionId]: value,
      }));
    },
    []
  );

  const updateCheckboxResponse = React.useCallback(
    (questionId: string, answerId: string, checked: boolean) => {
      setResponses((prev) => {
        const currentAnswers = prev[questionId]
          ? prev[questionId].split(',')
          : [];
        let newAnswers: string[];

        if (checked) {
          newAnswers = [...currentAnswers, answerId];
        } else {
          newAnswers = currentAnswers.filter((id) => id !== answerId);
        }

        return {
          ...prev,
          [questionId]: newAnswers.join(','),
        };
      });
    },
    []
  );

  const updateMatrixResponse = React.useCallback(
    (questionId: string, rowId: string, answerId: string) => {
      setResponses((prev) => {
        const currentMatrixAnswers = prev[questionId]
          ? JSON.parse(prev[questionId])
          : {};

        currentMatrixAnswers[rowId] = answerId;

        return {
          ...prev,
          [questionId]: JSON.stringify(currentMatrixAnswers),
        };
      });
    },
    []
  );

  const updateEssayResponse = React.useCallback(
    (questionId: string, text: string, question: Question) => {
      const normalizedText = text || '-';
      if (question.maxLength && normalizedText.length > question.maxLength) {
        return;
      }
      updateResponse(questionId, normalizedText);
    },
    [updateResponse]
  );

  return {
    responses,
    updateResponse,
    updateCheckboxResponse,
    updateMatrixResponse,
    updateEssayResponse,
  };
};
